import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router';
import { push } from 'react-router-redux';
import { openModal } from '../../actions/ModalActions';
import discountApi from '../../components/discounts/discountApi';
import CouponFormModal from '../../components/discounts/CouponFormModal';
import { shortDate, couponTerms, labelClass } from '../../utils/discountFormat';

/**
 * OPE-112 V2.7: the Discounts landing page is the coupon catalogue, as
 * in Stripe. A coupon is the reusable terms; its page is where the
 * promotion codes that give it away are added.
 */
@connect(
    state => ({ canManage: state.auth.user.permissions.includes('MANAGE_DISCOUNTS') }),
    dispatch => bindActionCreators({ openModal, push }, dispatch)
)
export default class Coupons extends Component {
    constructor(props) {
        super(props);
        this.state = { coupons: null, reference: null, state: '', error: null };
    }

    componentDidMount() {
        document.title = 'Coupons | Discounts | Fergus CRM';
        discountApi.referenceData().then(reference => this.setState({ reference })).catch(error => this.setState({ error: error.message }));
        this.load();
    }

    componentWillUnmount() {
        document.title = 'Fergus CRM';
    }

    load(filters = {}) {
        var state = filters.state !== undefined ? filters.state : this.state.state;
        var query = {};
        if (state) { query.state = state; }
        this.setState({ coupons: null, error: null, state });
        discountApi.listCoupons(query)
            .then(coupons => this.setState({ coupons }))
            .catch(error => this.setState({ error: error.message, coupons: [] }));
    }

    openCreate() {
        // Stripe lands on the new coupon, where the codes get added
        this.props.openModal(CouponFormModal, { reference: this.state.reference, onDone: coupon => this.props.push(`/discounts/coupons/${coupon.coupon_id}`) });
    }

    render() {
        var { coupons, reference, state, error } = this.state;
        return (
            <div className="row page-todo">
                <ol className="breadcrumb page-breadcrumb">
                    <li className="active">Coupons</li>
                </ol>
                <div className="col-md-12">
                    <div className="panel panel-default">
                        <div className="panel-heading" style={{ display: 'flex', alignItems: 'center' }}>
                            <h2 style={{ flex: 1, margin: 0 }}><i className="fa fa-ticket"></i> Coupons</h2>
                            <select className="form-control input-sm" style={{ width: 140, marginRight: 8 }} value={state} onChange={e => this.load({ state: e.target.value })}>
                                <option value="">All</option>
                                {['draft', 'active', 'archived'].map(s => <option key={s} value={s}>{s}</option>)}
                            </select>
                            <Link to="/discounts/promotions" className="btn btn-sm btn-default" style={{ marginRight: 8 }}><i className="fa fa-tag"></i> All promotion codes</Link>
                            <Link to="/discounts/cmr" className="btn btn-sm btn-default" style={{ marginRight: 8 }}><i className="fa fa-table"></i> CMR report</Link>
                            <Link to="/discounts/simulate" className="btn btn-sm btn-default" style={{ marginRight: 8 }}><i className="fa fa-flask"></i> Simulate billing</Link>
                            {this.props.canManage && reference &&
                                <button type="button" className="btn btn-sm btn-info" onClick={this.openCreate.bind(this)}><i className="fa fa-plus-square"></i> New coupon</button>
                            }
                        </div>
                        <div className="panel-body no-padding">
                            {error && <div className="alert alert-danger" style={{ margin: 10 }}>{error}</div>}
                            {coupons === null && !error && <p className="text-muted" style={{ padding: 10 }}>Loading...</p>}
                            {coupons && coupons.length === 0 && <p className="text-muted" style={{ padding: 10 }}>No coupons yet. A coupon is the terms — "20% off for 3 months" — and its page is where the promotion codes that give it away are added.</p>}
                            {coupons && coupons.length > 0 &&
                                <table className="table table-hover" style={{ marginBottom: 0 }}>
                                    <thead>
                                        <tr><th>Name</th><th>Terms</th><th>Status</th><th className="text-right">Redemptions</th><th>Promotion codes</th><th>Expires</th><th>Created</th></tr>
                                    </thead>
                                    <tbody>
                                        {coupons.map(c =>
                                            <tr key={c.coupon_id} className={c.state === 'archived' ? 'text-muted' : ''}>
                                                <td><Link to={`/discounts/coupons/${c.coupon_id}`}>{c.invoice_name}</Link><div className="text-muted"><small>{c.slug}</small></div></td>
                                                <td>{couponTerms(c)}</td>
                                                <td><span className={labelClass(c.state)}>{c.state}</span></td>
                                                <td className="text-right">{c.times_redeemed}{c.max_redemptions ? ` / ${c.max_redemptions}` : ''}</td>
                                                <td>{c.promotion_count > 0 ? c.promotion_count : <span className="label label-default">Not in use</span>}</td>
                                                <td>{c.redeem_by ? shortDate(c.redeem_by) : <span className="text-muted">—</span>}</td>
                                                <td>{shortDate(c.created_at)}</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./app/pages/discounts/Coupons.js